import {Typography, Card, CardContent, Grid, Tooltip, IconButton, useMediaQuery, useTheme} from "@mui/material";
import { TrendCardMetric } from "./TrendCardMetric";
import {ActiveTrend} from "../../../../types/nbaTypes";
import {useNavigate} from "react-router-dom";
import {Info} from "@mui/icons-material";

export const TrendCard = (
        {
            trend,
            sport = 'nba',
            fullWidth = false,
        }:
        {
            trend?: ActiveTrend,
            sport: string
            fullWidth: boolean
        }) => {

    const navigate = useNavigate()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const handleNavigate = (trendText?: string) => {
        return navigate(`/${sport}-query?query-string=${trend?.trend}`)
    }

    return (
                <Card
                    key={trend?.activeGames?.[0]?.activeTeam}
                    sx={{
                        maxWidth: '216px',
                         '&:hover': {
                            backgroundColor: theme.palette.grey[500],
                            cursor: 'pointer',
                        },
                    }}
                    onClick={() => handleNavigate(trend?.trend)}
                >
                    <CardContent>
                        <Typography
                            variant="caption"
                            component="p"
                            align="center"
                            mb={1}
                        >
                            {trend?.trendDescription || trend?.trend}
                            <Tooltip title={`SDQL Query: ${trend?.trend}`} disableHoverListener={isMobile}
                            >
                                <IconButton size='small'>
                                    <Info
                                        style={{
                                            fontSize: '12px',
                                            color: theme.palette.grey[500]
                                        }}
                                    />
                                </IconButton>
                            </Tooltip>
                        </Typography>
                        <Grid
                            container
                            item
                            xs={12}
                            sm={12}
                            display="flex"
                            justifyContent="space-between"
                            flexDirection="row"
                            flexWrap='wrap'
                        >
                            <TrendCardMetric
                                value={`${trend?.wins} - ${trend?.losses}`}
                                label={'W-L'}
                            />
                            <TrendCardMetric
                                value={`${trend?.atsWins} - ${trend?.atsLosses}`}
                                label={'ATS W-L'}
                            />
                            <TrendCardMetric
                                value={`${trend?.overs} - ${trend?.unders}`}
                                label={'OV-UN'}
                            />
                            <TrendCardMetric
                                value={`${trend?.points?.toFixed(1) || 0} - ${trend?.oPoints?.toFixed(1) || 0}`}
                                label={'Score'}
                            />
                        </Grid>
                    </CardContent>
                </Card>
    );
}
